"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = require("react");

var _client = require("@apollo/client");

var _notification = _interopRequireDefault(require("antd/lib/notification"));

var _locales = require("@meepshop/locales");

var _link = require("@meepshop/link");

var _AdTrack = _interopRequireDefault(require("@meepshop/context/lib/AdTrack"));

// import
// definition
var _default = function _default() {
  var _useTranslation = (0, _locales.useTranslation)('fb'),
      t = _useTranslation.t;

  var client = (0, _client.useApolloClient)();
  var router = (0, _link.useRouter)();
  var adTrack = (0, _react.useContext)(_AdTrack["default"]);
  var prevAccessTokenRef = (0, _react.useRef)(null);
  return (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(accessToken, redirectPath) {
      var res, _yield$res$json, code;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(accessToken === prevAccessTokenRef.current)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", true);

            case 2:
              prevAccessTokenRef.current = accessToken;
              _context.next = 5;
              return fetch('/api/auth/fb-login', {
                method: 'post',
                headers: {
                  'Content-Type': 'application/json'
                },
                credentials: 'same-origin',
                body: JSON.stringify({
                  accessToken: accessToken
                })
              });

            case 5:
              res = _context.sent;

              if (!(res.status !== 200)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", false);

            case 8:
              _context.next = 10;
              return res.json();

            case 10:
              _yield$res$json = _context.sent;
              code = _yield$res$json.code;
              _context.t0 = code;
              _context.next = _context.t0 === 200 ? 15 : _context.t0 === 201 ? 15 : _context.t0 === 2010 ? 20 : _context.t0 === 2011 ? 22 : _context.t0 === 2003 ? 24 : 26;
              break;

            case 15:
              _context.next = 17;
              return client.resetStore();

            case 17:
              if (201) adTrack.completeRegistration();
              if (redirectPath) router.push(redirectPath);
              return _context.abrupt("return", true);

            case 20:
              _notification["default"].error({
                message: t('cannot-use')
              });

              return _context.abrupt("return", false);

            case 22:
              _notification["default"].error({
                message: t('cannot-get-email')
              });

              return _context.abrupt("return", false);

            case 24:
              _notification["default"].error({
                message: t('cannot-use')
              });

              return _context.abrupt("return", false);

            case 26:
              _notification["default"].error({
                message: t('login-fail'),
                description: t('login-fail-description')
              });

              return _context.abrupt("return", false);

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [t, client, router, adTrack]);
};

exports["default"] = _default;